import { getConfig } from 'config';
import { Legend, StationStatus, StationType } from 'pages/Map/types';
import colors from 'theme/colors';

/**
 * These (X_SCALE_VALUE, Y_SCALE_VALUE) are the number of pixels to be for 1 xPosition/yPosition given by map producer, to place stations in proper distance
 * likely to update these values after map producer gives all maps, and adjust to render properly
 */
export const X_SCALE_VALUE = 300;
export const Y_SCALE_VALUE = 150;
export const STATION_DESCRIPTION_WIDTH = 250; //Width of the station description
export const PATH_SELECTION_MODAL_SIZE = {
    height: 114,
    width: 272
};
export const Y_STEP_UP = Y_SCALE_VALUE / 2;
export const X_STEP_UP = X_SCALE_VALUE / 2;
// Map places stations & paths in particular xy positions, there is no space around these stations. These constants are used to provide additional gap(in pixels) around map
const ADDITIONAL_SPACE_ON_HORIZONTAL_AXIS = 10000;
export const ADDITIONAL_SPACE_ON_SIDES = {
    left: ADDITIONAL_SPACE_ON_HORIZONTAL_AXIS,
    right: ADDITIONAL_SPACE_ON_HORIZONTAL_AXIS,
    bottom: 500,
    top: 100
};
export const DIRECTION_ICON_LENGTH = 15;
export const PATH_WIDTH = 28;
export const STATION_ICON_SIZE = PATH_WIDTH;
export const STATION_SIZE = 40;
export const CANCER_MAPS = 'Cancer Maps.';
export const COMING_SOON = 'Coming Soon.';
export const COMING_SOON_PARA1 =
    'This map is designed for cancer patients to assist them in their difficult journey. It provides all the available, evidence-based paths for the specific cancer experience you are traversing. The map will be loaded in here within the next 24 hours. We will send you an email once it’s ready.';
export const COMING_SOON_PARA2 = 'In meantime, explore our gear section to see helpful tools you can use along the way.';
export const GO_TO_GEAR = 'Go To Gear';
export const MAP_INFO = 'Map Info';
export const ABOUT_MAP_QUESTION = 'What is this Map about?';
export const ABOUT_MAP_PARA1 =
    'A cancer journey map is a visual representation of the patient experience throughout the cancer care process. It typically includes all the different stages of the journey, from diagnosis to treatment and follow-up care. It may also include information about the emotional and practical challenges that patients and their families face, as well as resources and support available to them.';
export const ABOUT_MAP_PARA2 =
    'The goal of a cancer journey map is to help patients and their families understand what to expect and to provide a clear and comprehensive overview of the care process. It may also be used by healthcare providers to identify areas of improvement in the patient experience and to make changes to the care process.';
export const HOW_TO_USE_MAP = 'How to use the map';
export const HOW_TO_USE_MAP_PARA1 =
    'In order to use the map, you need to understand these 6 legends and their working. Each of them has a special purpose and meaning.';
export const HOW_TO_USE_MAP_PARA2 =
    'Some of these legends would be added to your map by default. Some of them would get added as you progress along your journey. As you add appointments, symptoms, get tests & treatment done, and you log all that in your Manta Cares Account, the map will plot all those legends in your journey to provide you and your care team with a big picture of how things are coming along.';
export const MAP_USEFUL_QUESTION = 'Do you find the map useful?';
export const TELL_US_PARA =
    "Tell us what you think & share your experience with it. It'd help us provide better experience to several other cancer patients.";
export const MAP_INFO_HEADER = 'Maps are assigned with information from onboarding.';
export const ISSUES_WITH_MAP = 'Issues with your map?';
export const CONTACT_ADMIN = 'Contact Manta Cares Admin';
export const Legends: Legend[] = [
    { type: StationType.ZoneStart, label: 'Zone Start' },
    { type: StationType.SubZone, label: 'Subzone' },
    { type: StationType.Decision, label: 'Decision Point' },
    { type: StationType.ZoneEnd, label: 'Completion', altLabel: 'End Treatment' },
    { type: StationType.Info, label: 'Informative Point' },
    { type: StationType.Transition, label: 'Transition between Zones', altLabel: 'Transition to next zone' }
];
export const WELCOME_TO_MAPS_VIDEO_URL = getConfig().S3_PUBLIC_ASSETS_URL + '/videos/welcomeToMap.mp4';
export const MAP_AD_VIDEO_URL = getConfig().S3_PUBLIC_ASSETS_URL + '/videos/mapAd.mp4';
export const MAP_TUTORIAL_VIDEO_URL = getConfig().S3_PUBLIC_ASSETS_URL + '/videos/mapTutorial.mp4';

export const StationColor: Record<StationStatus, string> = {
    [StationStatus.TRAVELLED]: colors.yellow[500],
    [StationStatus.NOT_TRAVELLED]: colors.silverGrey[500],
    [StationStatus.ACTIVE_STATION]: colors.coral[500],
    [StationStatus.DEFAULT]: colors.royalBlue[200],
    [StationStatus.SELECTED]: colors.darkBlue
};

export const DESCRIPTION_CHARACTER_LENGTH = 48; //Character length description
export const PATH_ID_SEPARATOR = '_';
